import { useSyncExternalStore } from 'react'
const KEY = 'relaii:external-images:v1'
const EVENT = 'relaii:external-images-changed'

function allowed(): boolean {
  try { return window.localStorage.getItem(KEY) === 'allow' } catch { return false }
}
function subscribe(listener: () => void): () => void {
  window.addEventListener('storage', listener)
  window.addEventListener(EVENT, listener)
  return () => { window.removeEventListener('storage', listener); window.removeEventListener(EVENT, listener) }
}
export function useExternalImages(): boolean { return useSyncExternalStore(subscribe, allowed, () => false) }
export function setExternalImages(allow: boolean): void {
  try { window.localStorage.setItem(KEY, allow ? 'allow' : 'ask') } catch { /* Keep the safer default. */ }
  window.dispatchEvent(new Event(EVENT))
}
